import type {
  DeviceGroupAttribute,
  PathLookupResultFlag,
} from '@ipfabric/utils';

/**
 * API requires `groupBy` since https://ipfabric.atlassian.net/browse/NIM-4463 .
 *
 * In future there should be some option to change this attribute and draw
 * bounding boxes in pathlookup by any groupBy attribute, but for now
 * path lookup requests are hardcoded to `groupBy: 'siteName'` in frontend.
 *
 * Therefore it is not "default" value but rather "currently hardcoded".
 */
export const PATH_LOOKUP_GROUP_BY: DeviceGroupAttribute = 'siteName';

/**
 * Subset of path lookup result flags that may be a potential cause of returning empty graph
 *
 * Presence of this flag doesn't automatically mean path lookup result is empty,
 * but when path lookup result is empty, one or more of these flag should appear
 * in the result (otherwise we experienced some completely unexpected state).
 *
 * So, we may use these flags to tell user why he doesn't see any graph.
 */
export const emptyPathLookupResultCauses = [
  'cloud-source-ip-not-assigned',
  'no-dgw',
  'no-receiver',
  'no-source',
  'simulation-error',
] satisfies PathLookupResultFlag[];

export type EmptyPathLookupResultCause =
  (typeof emptyPathLookupResultCauses)[number];

export const isEmptyPathLookupResultCause = (
  flag: PathLookupResultFlag,
): flag is EmptyPathLookupResultCause =>
  (emptyPathLookupResultCauses as PathLookupResultFlag[]).includes(flag);
